<h3>Synchronizations Shopify</h3>
<div class="container-fluid" *ngIf="inventoryMovementsPage && productsPage">
  <div class="row">
    <div class="col-lg-4 mb-3">
      <label for="disabledTextInput" class="form-label">Dernière synchronization</label>
      <input type="text" id="disabledTextInput" class="form-control" placeholder="{{ lastSynchronization | date:'yyyy-MM-dd HH:mm:ss'}}">
    </div>
    <div class="col-lg-4 mb-3">
      &nbsp;
    </div>

    <div class="col-lg-4 mb-3 text-center">
      <label for="disabledTextInput" class="form-label">
        &nbsp;
      </label>
      <div>
        <button 
          type="submit"
          (click)="retryErrors()"
          class="btn btn-primary"
        >Retraiter les erreurs</button>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12">
      <h5>Références</h5>
      <div class="table-responsive">
        <table class='table table-sm text-center'>
          <thead>
            <tr>
              <th>Isbn</th>
              <th class="text-left">Titre</th>
              <th>Identifiant Shopify</th>
              <th>Date création</th>
              <th>Date mise à jour</th>
              <th>Date traitement</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let product of productsPage.content">
              <td><a [href]="'/inventory/reference/' + product.isbn">{{ product.isbn }}</a></td>
              <td class="text-left">{{ product.title }}</td>
              <td>{{ product.shopifyId }}</td>
              <td>{{ product.creationTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>{{ product.updateTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>{{ product.processedTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>
                <div [ngSwitch]="product.status">
                  <span class="badge badge-success" *ngSwitchCase="'PROCESSED'">
                    Traité
                  </span>
                  <span class="badge badge-warning" *ngSwitchCase="'TO_PROCESS'">À traiter</span>
                  <button class="btn btn-sm btn-danger" *ngSwitchCase="'ERROR'" (click)="openErrorMessage(product.errorMessage)">
                    Erreur
                  </button>
                  <span class="badge badge-dark" *ngSwitchDefault>Inconnu</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <h5>Inventaire</h5>
      <div class="table-responsive">
        <table class='table table-sm text-center'>
          <thead>
            <tr>
              <th>Isbn</th>
              <th class="text-left">Titre</th>
              <th>Quantité</th>
              <th>Date création</th>
              <th>Date traitement</th>
              <th>Statut</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let inventoryMovement of inventoryMovementsPage.content">
              <td><a [href]="'/inventory/reference/' + inventoryMovement.isbn">{{ inventoryMovement.isbn }}</a></td>
              <td class="text-left">{{ inventoryMovement.title }}</td>
              <td>{{ inventoryMovement.quantity }}</td>
              <td>{{ inventoryMovement.creationTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>{{ inventoryMovement.processedTimestamp | date:'yyyy-MM-dd HH:mm:ss'}}</td>
              <td>
                <div [ngSwitch]="inventoryMovement.status">
                  <span class="badge badge-success" *ngSwitchCase="'PROCESSED'">
                    Traité
                  </span>
                  <span class="badge badge-warning" *ngSwitchCase="'TO_PROCESS'">À traiter</span>
                  <button class="btn btn-sm btn-danger" *ngSwitchCase="'ERROR'" (click)="openErrorMessage(inventoryMovement.errorMessage)">
                    Erreur
                  </button>
                  <span class="badge badge-dark" *ngSwitchDefault>Inconnu</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<ng-template #modal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Erreur shopify</h4>
    <button type="button" class="close" (click)="modal.dismiss()">
      <span>&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <pre>{{ errorToDisplay }}</pre>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="modal.close()">Fermer</button>
  </div>
</ng-template>